import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrl: './card.component.scss',
})
export class CardComponent {
  @Input() variant: Variant = 'default';

  get ngClass() {
    return {
      [`variant-${this.variant}`]: true,
    };
  }
}

type Variant = (typeof variants)[number];

const variants = ['default', 'tight', 'financial'];
